// ════════════════════════════════════════════════════════════════════
// src/components/Protegido.js — a guarda de rota
// ════════════════════════════════════════════════════════════════════
// Esconder o item do menu não protege nada: basta digitar /relatorios na
// barra de endereço. Esta guarda é a que barra de verdade no front.
//
// (E nem ela é a última palavra — quem protege o DADO é a regra do
// Firestore. Esta aqui existe para a pessoa ver uma tela decente em vez
// de uma página quebrada cheia de erro de permissão no console.)
// ════════════════════════════════════════════════════════════════════

import { useAuth } from '../context/AuthContext';
import { AREAS, PAPEIS, labelPapel } from '../permissoes';

export default function Protegido({ area, children }) {
  const { user, papel, pode, vinculo } = useAuth();

  // Deslogado continua como era: cada tela mostra o próprio convite de
  // login (com o LoginModal). Não mudamos esse comportamento aqui.
  if (!user) return children;

  if (vinculo?.suspenso) return <Aviso tipo="suspenso" />;

  if (area && !pode(area)) return <Aviso tipo="semAcesso" area={area} papel={papel} />;

  return children;
}

function Aviso({ tipo, area, papel }) {
  const suspenso = tipo === 'suspenso';
  const liberadas = (PAPEIS[papel]?.areas || [])
    .filter(a => a !== 'home' && a !== 'chamados')
    .map(a => AREAS[a]);

  return (
    <div style={{ maxWidth: '960px', margin: '0 auto' }}>
      <div style={{
        background: '#fff', border: '1px solid rgba(0,0,0,0.08)', borderRadius: '14px',
        padding: '32px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        maxWidth: '460px', margin: '60px auto', textAlign: 'center'
      }}>
        <div style={{ fontSize: '34px', marginBottom: '14px' }}>{suspenso ? '⏸' : '🔒'}</div>
        <h2 style={{ fontFamily: 'Syne, sans-serif', fontSize: '18px', fontWeight: '800', marginBottom: '10px' }}>
          {suspenso ? 'Seu acesso está suspenso' : 'Você não tem acesso a esta tela'}
        </h2>
        <p style={{ color: '#52526e', fontSize: '13px', lineHeight: 1.6 }}>
          {suspenso ? (
            <>O administrador da conta pausou seu acesso. Fale com ele para reativar.</>
          ) : (
            <>
              <strong>{AREAS[area] || 'Esta área'}</strong> é restrita.
              Seu acesso é de <strong>{labelPapel(papel)}</strong>.
              {liberadas.length > 0 && (
                <><br /><br />
                  <span style={{ fontSize: '12px', color: '#9898b8' }}>
                    Você pode usar: {liberadas.join(' · ')}
                  </span>
                </>
              )}
              <br /><br />
              <span style={{ fontSize: '12px' }}>
                Se precisa desta tela, peça ao administrador para mudar seu papel em <strong>Equipe</strong>.
              </span>
            </>
          )}
        </p>
      </div>
    </div>
  );
}
